import {
  CreateExchangeRateRequest,
  ExchangeRate,
  UpdateExchangeRateRequest,
} from "../types/admin";
import { ApiResponse } from "../types/common";

import apiClient from "./apiClient";

export const getExchangeRates = async (): Promise<
  ApiResponse<ExchangeRate[]>
> => {
  const response = await apiClient.get("/admin/exchange-rates");
  return response.data;
};

export const createExchangeRate = async (
  data: CreateExchangeRateRequest
): Promise<ApiResponse<ExchangeRate>> => {
  const response = await apiClient.post("/admin/exchange-rates", data);
  return response.data;
};

export const updateExchangeRate = async (
  id: string,
  data: UpdateExchangeRateRequest
): Promise<ApiResponse<ExchangeRate>> => {
  const response = await apiClient.put(`/admin/exchange-rates/${id}`, data);
  return response.data;
};

export const deleteExchangeRate = async (
  id: string
): Promise<ApiResponse<object>> => {
  const response = await apiClient.delete(`/admin/exchange-rates/${id}`);
  return response.data;
};

export const changeExchangeRateStatus = async (
  id: string,
  isActive: boolean
): Promise<ApiResponse<boolean>> => {
  const response = await apiClient.patch(
    `/admin/exchange-rates/${id}/status?isActive=${isActive}`
  );
  return response.data;
};
